import React, { Component } from 'react';
import { connect, PromiseState } from 'react-refetch';

import $ from 'jquery';

import { api } from '../../data';

import LoadingAnimation from '../modules/LoadingAnimation';

class Services extends Component {

  scrollToAnchor() {
    let anchorName = this.props.location.hash;
    if (anchorName) {
      let anchorElement = $(anchorName);
      if(anchorElement) {
        $('html, body').animate({
          scrollTop: anchorElement[0].offsetTop
        }, 300);
      }
    }
  }

  componentDidMount() {
    this.scrollToAnchor();
  }

  render() {
    const childrenWithProps = React.Children.map(this.props.children, (child) => {
        return React.cloneElement(child, {page: this.props.page});
    });

    return ( <div>{childrenWithProps}</div> )
  }
}

class ServicesFetch extends Component {
  render() {

    const { pageFetch } = this.props;

    const allFetches = PromiseState.all([pageFetch])

    // Pending
    if (allFetches.pending) {

      return <LoadingAnimation />

    // Error
    } else if (allFetches.rejected) {

      return <div>Error</div>

    // Complete without Error
    } else if (allFetches.fulfilled) {

      let [page] = allFetches.value;
      page = page[0];

      return (
        <div>
          <Services page={page} {...this.props} />
        </div>
      )
    }
  }
}

export default connect(props => ({
  pageFetch: `${api.base_url}/pages?slug=${props.location.pathname.replace('/services/', '').replace('/\//g', '')}`
}))(ServicesFetch);



/** WEBPACK FOOTER **
 ** ./src/components/Services/Index.js
 **/